import React from 'react';

import { StyledChip } from './styles';
import type { ChipProps } from './types';

export default function Chip(props: ChipProps): JSX.Element {
  return <StyledChip {...props} />;
}
